import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';
import HreflangTags from './HreflangTags';
import Breadcrumbs from './Breadcrumbs';
import { ReactNode } from 'react';

const Layout = ({ children }: { children: ReactNode }) => (
  <div className="min-h-screen flex flex-col">
    <HreflangTags />
    <SiteHeader />
    <Breadcrumbs />
    <main className="flex-1">{children}</main>
    <SiteFooter />
  </div>
);

export default Layout;
